import styled from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

export const Card = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 20px;
  margin-bottom: 24px;
  padding: 26px;
  border-radius: ${radius.xl};
  color: #FFFFFF;
  background:
    radial-gradient(120% 140% at 100% 0%, rgba(244, 182, 63, 0.35) 0%, rgba(244, 182, 63, 0) 45%),
    linear-gradient(135deg, ${colors.brandDark} 0%, ${colors.brandDeep} 65%, ${colors.brand} 100%);
  box-shadow: ${shadow.raised};

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 22px;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
`;

export const Hello = styled.h2`
  font-family: ${font.text};
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
`;

export const Next = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const NextIcon = styled.span`
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: ${radius.md};
  background: rgba(255, 255, 255, 0.16);
`;

export const NextLabel = styled.span`
  display: block;
  font-family: ${font.text};
  font-size: 13px;
  font-weight: 600;
  opacity: 0.8;
`;

export const NextValue = styled.span`
  display: block;
  font-family: ${font.text};
  font-size: 18px;
  font-weight: 800;
`;

export const Action = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 800;
  color: ${colors.brandDark};
  background: #FFFFFF;
  cursor: pointer;
  transition: transform 0.15s ease;

  &:hover {
    transform: translateX(2px);
  }
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(140px, 1fr));
  gap: 12px;
  align-self: center;

  @media (max-width: 900px) {
    align-self: stretch;
  }
`;

export const Stat = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 16px 18px;
  border-radius: ${radius.lg};
  text-align: left;
  color: #FFFFFF;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.16);
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.16);
  }
`;

export const StatValue = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${font.text};
  font-size: 30px;
  font-weight: 800;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
`;

export const StatLabel = styled.span`
  font-family: ${font.text};
  font-size: 13px;
  font-weight: 600;
  opacity: 0.8;
`;
